import { createGlobalStyle } from 'styled-components';

export const ToastStyles = createGlobalStyle`
  .Toastify__toast-container {
    width: auto !important;
    max-width: 600px;
    padding: 0;
  }

  .custom-toast-success {
    background: #E8F5E9 !important;
    border: 2px solid #4CAF50 !important;
    border-radius: 16px !important;
    padding: 16px 20px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    min-height: auto !important;
    font-family: 'IBM Plex Sans Thai', sans-serif !important;
  }

  .custom-toast-success .Toastify__toast-icon {
    width: 28px !important;
    height: 28px !important;
    background: #4CAF50 !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 12px !important;
    font-size: 18px !important;
    color: white !important;
    flex-shrink: 0 !important;
  }

  .custom-toast-success .Toastify__close-button {
    position: absolute !important;
    right: 12px !important;
    top: 12px !important;
    color: #333 !important;
    opacity: 0.7 !important;
  }

  .custom-toast-success .Toastify__close-button:hover {
    opacity: 1 !important;
  }

  .custom-toast-body {
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }

  .custom-toast-title {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #333 !important;
    margin: 0 !important;
  }

  .custom-toast-message {
    font-size: 16px !important;
    font-weight: 400 !important;
    color: #666 !important;
    margin: 0 !important;
  }

  .custom-toast-error {
    background: #FFEBEE !important;
    border: 2px solid #F44336 !important;
    border-radius: 16px !important;
    padding: 16px 20px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    min-height: auto !important;
    font-family: 'IBM Plex Sans Thai', sans-serif !important;
  }

  .custom-toast-error .Toastify__toast-icon {
    width: 28px !important;
    height: 28px !important;
    background: #F44336 !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 12px !important;
    font-size: 18px !important;
    color: white !important;
    flex-shrink: 0 !important;
  }

  .custom-toast-warning {
    background: #FFF3E0 !important;
    border: 2px solid #FF9800 !important;
    border-radius: 16px !important;
    padding: 16px 20px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    min-height: auto !important;
    font-family: 'IBM Plex Sans Thai', sans-serif !important;
  }

  .custom-toast-warning .Toastify__toast-icon {
    width: 28px !important;
    height: 28px !important;
    background: #FF9800 !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 12px !important;
    font-size: 18px !important;
    color: white !important;
    flex-shrink: 0 !important;
  }

  .custom-toast-warning .Toastify__close-button {
    position: absolute !important;
    right: 12px !important;
    top: 12px !important;
    color: #333 !important;
    opacity: 0.7 !important;
  }

  .custom-toast-warning .Toastify__close-button:hover {
    opacity: 1 !important;
  }
`;
